module.exports = __webpack_public_path__ + "img/Bolt.af567b6d.svg";